import { useRef, useCallback } from 'react'

export default function usePhoneControl({ send }) {
  const containerRef = useRef(null)

  const translateClick = useCallback((clientX, clientY, phoneWidth, phoneHeight) => {
    if (!containerRef.current) return { x: 0, y: 0 }
    const rect = containerRef.current.getBoundingClientRect()
    const scaleX = phoneWidth / rect.width
    const scaleY = phoneHeight / rect.height
    const x = Math.round((clientX - rect.left) * scaleX)
    const y = Math.round((clientY - rect.top) * scaleY)
    return { x, y }
  }, [])

  const handleClick = useCallback(
    (e, phoneWidth, phoneHeight) => {
      const { x, y } = translateClick(e.clientX, e.clientY, phoneWidth, phoneHeight)
      send({ type: 'touch_tap', x, y })
    },
    [translateClick, send]
  )

  const handleSwipe = useCallback(
    (direction) => {
      send({ type: 'swipe', direction })
    },
    [send]
  )

  const sendBack = useCallback(() => {
    send({ type: 'key', key: 'BACK' })
  }, [send])

  const sendHome = useCallback(() => {
    send({ type: 'key', key: 'HOME' })
  }, [send])

  return {
    containerRef,
    translateClick,
    handleClick,
    handleSwipe,
    sendBack,
    sendHome,
  }
}
